//右クリック禁止
//--------------------------------------------------------------------
document.oncontextmenu = function () {return false;}

$(function () {
  //remarketing
  //--------------------------------------------------------------------
  var hostname = window.location.hostname;
  if(hostname=="www.carddass.com"){
    $.ajax({
      type: 'GET',
      url: '/share/remarketing.html',
      dataType: 'html',
      success: function (data) {
        $('body').append(data);
      },
    });
  }
  //hover
  //--------------------------------------------------------------------
  $("a img").hover(
    function (){
      $(this).stop(false, false).animate({"opacity":"0.7"},'fast',"linear")
    },
    function (){
      $(this).stop(false, false).animate({"opacity":"1"},1000,"easeOutBounce")
    }
  );

  $('.linkBasicHvr').mouseover(function () {
    $(this).css('opacity', '.6').animate({
      'opacity': '1'
    }, 'easeOutElastic');
  });

  //Smooth Scroll
  //--------------------------------------------------------------------
  $('a[href^="#"],.anchor').on("click", function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, 'easeOutCubic');
    return false;
  });

  //pTopボタン
  //--------------------------------------------------------------------
  var nav = $('.btnPageTop');
  var triggerNode = $("footer");
  $(window).scroll(function(){
    var triggerNodePosition = $(triggerNode).offset().top - $(window).height();
    if ($(window).scrollTop() > triggerNodePosition) {
      nav.addClass('abs');
      nav.removeClass('fxd');
    } else {
      nav.addClass('fxd');
      nav.removeClass('abs');
    }
  });
});

//gnaviSP
//--------------------------------------------------------------------
$(window).on('load',function(){
  menutoggle=0;
  $("#btnGnOpen,#btnGnClose").click(function () {
    $("#gnavi").stop().slideToggle();
    if(menutoggle==0) {
      menutoggle=1;
      $("#gnavi").css("height","100%");
      var changeGn = $("#btnGnOpen a img").attr('src').replace('btn_gnavi_menu.png' , 'btn_gnavi_menu_on.png');
      $("#btnGnOpen a img").attr('src', changeGn);
    } else {
      menutoggle=0;
      $("#gnavi").css("height","");
      var changeGn = $("#btnGnOpen a img").attr('src').replace('btn_gnavi_menu_on.png' , 'btn_gnavi_menu.png');
      $("#btnGnOpen a img").attr('src', changeGn);
    }
  });
});

//Resize
//-------------------------------------------------------------------
var timer = false;
$(window).resize(function() {
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function() {
    var windowsize = $(window).width();
    if(windowsize <= 768 ){
    }else{
      $("#gnavi").css("display", "block");
    }
  }, 300);
});

//YouTube
//-------------------------------------------------------------------
$(document).ready(function() {
  $(".youtube").fancybox({
    fitToView : true,
    width : '960',
    height : '540',
    autoSize : true,
    closeClick : false,
    openEffect : 'none',
    closeEffect : 'none',
    nextEffect : 'none',
    prevEffect : 'none'
  });
});